import { FC, useEffect, useState } from "react";
import {
  SurveyAnswerDTO,
  SurveyAnswerRequestDTO,
  SurveyDTO,
} from "../../api/Api";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./feedback-question.scss";
import { ReactComponent as CrossIcon } from "../../shared/images/svg/cross.svg";
import { ReactComponent as TelegramIcon } from "../../shared/images/svg/telegrma.svg";
import { feedbackService } from "../../services/feedback-service";
import { links } from "../../config/links";
import { sendMetrics, MerticNames } from "../../utils/metrics";
import { Link, useNavigate } from "react-router";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../../services/localStorage-service";
import { Modal } from "../../ui/modal/modal";
import { promotionLinks } from "../../const/promotion-links";

type FeedbackQuestionProps = {
  isVoice: boolean;
  toFirstStep: () => void;
};
const feedbackQuestionCn = bemCN("feedback-question");

const colorsBtn = [ButtonColors.green, ButtonColors.orange, ButtonColors.red];

export const FeedbackQuestion: FC<FeedbackQuestionProps> = ({
  isVoice,
  toFirstStep,
}) => {
  const [activeIndexBtn, setActiveIndexBtn] = useState(-1);
  const [question, setQuestion] = useState<SurveyDTO>();
  const [isShowModal, setIsShowModal] = useState(true);
  const isAuth: boolean =
    localStorageService.getValue(LocalStorageVariableName.token) == undefined
      ? false
      : true;

  useEffect(() => {
    !question &&
      isAuth &&
      feedbackService.getQuestion().then((res: SurveyDTO) => {
        setQuestion(res);
      });
  }, [1]);

  const playAudioStep = (index: number) => {
    let audio = document.getElementById("answer_text") as HTMLAudioElement;
    let currentBtn: SurveyAnswerDTO | undefined = question?.answerList
      ? question?.answerList[index]
      : undefined;
    if (currentBtn && audio) {
      if (currentBtn.answerAudioUrl) {
        setActiveIndexBtn(index);
        audio.src = currentBtn.answerAudioUrl;
        audio.play();
        audio.onended = (e: any) => {
          playAudioStep(index + 1);
        };
      }
    } else {
      setActiveIndexBtn(-1);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      setQuestion(undefined);
      stopVoice();
      let textAudio = document.getElementById(
        "question_text"
      ) as HTMLAudioElement;
      if (textAudio) {
        textAudio.src = "";
      }
    };
  }, [1]);

  const stopVoice = () => {
    setActiveIndexBtn(-1);
  };

  const sendAnswer = (id?: number) => {
    question &&
      feedbackService
        .sendAnswer({
          questionId: question.questionId,
          answerId: id,
        } as SurveyAnswerRequestDTO)
        .then((res: any) => {
          setQuestion(undefined);
        });
  };

  if (question)
    return (
      <div className={feedbackQuestionCn()}>
        <p>{question.questionText}</p>
        {isVoice && (
          <>
            <audio
              id="question_text"
              onEnded={() => playAudioStep(0)}
              autoPlay
              src={question.audioUrl}
            ></audio>
            <audio id="answer_text"></audio>
          </>
        )}
        {question.answerList?.map((ans: SurveyAnswerDTO, index: number) => (
          <Button
            key={ans.answerId}
            id={activeIndexBtn === index ? "wiggle" : undefined}
            text={ans.answerText}
            size={ButtonSizes.big}
            color={
              question.questionId == 5 ? ButtonColors.green : colorsBtn[index]
            }
            onClick={() => sendAnswer(ans.answerId)}
          />
        ))}
      </div>
    );
  else
    return (
      <>
        {isVoice && (
          <>
            <audio
              autoPlay
              src="https://yumi-story.com/audio/buttons/another-story.mp3"
              onPlay={() => {
                let btnAnotherStory = document.getElementById(
                  "another_story_btn"
                ) as HTMLButtonElement;
                btnAnotherStory.classList.add("wiggle");
              }}
              onEnded={() => {
                let btnAnotherStory = document.getElementById(
                  "another_story_btn"
                ) as HTMLButtonElement;
                btnAnotherStory.classList.remove("wiggle");
                let audioEnd = document.getElementById(
                  "end_audio"
                ) as HTMLAudioElement;
                audioEnd.play();
              }}
            ></audio>
            <audio
              id="end_audio"
              // autoPlay
              src="https://yumi-story.com/audio/buttons/begin-start.mp3"
              onPlay={() => {
                let btnBeginStory = document.getElementById(
                  "begin_start_story_btn"
                ) as HTMLButtonElement;
                btnBeginStory.classList.add("wiggle");
              }}
              onEnded={() => {
                let btnBeginStory = document.getElementById(
                  "begin_start_story_btn"
                ) as HTMLButtonElement;
                btnBeginStory.classList.remove("wiggle");
              }}
            ></audio>
          </>
        )}
        <Button
          id="another_story_btn"
          onClick={() => {
            sendMetrics("reachGoal", MerticNames.endReadStory);
            navigate(links.stories);
          }}
          text={"Прочитать другую историю"}
          color={ButtonColors.green}
          size={ButtonSizes.big}
        />
        <Button
          id="begin_start_story_btn"
          onClick={() => {
            toFirstStep();
          }}
          text={"Начать с начала"}
          color={ButtonColors.violet}
          size={ButtonSizes.big}
        />
        {!isAuth && (
          <Modal
            setIsShowDialog={setIsShowModal}
            isShowDialog={isShowModal}
            id={"tlgrModal"}
          >
            <div className={feedbackQuestionCn("tgModal")}>
              <Button
                onClick={() => setIsShowModal(false)}
                icon={<CrossIcon />}
                color={ButtonColors.transition}
                size={ButtonSizes.small}
              />
              <p>
                О новых сказках, конкурсах и подарках первыми узнают подписчики
              </p>
              <Button
                icon={<TelegramIcon />}
                text="наш Telegram"
                size={ButtonSizes.big}
                color={ButtonColors.green}
                onClick={() => {
                  sendMetrics("reachGoal", MerticNames.telegramRedirect);
                  window.open(promotionLinks.telegram, "_blank");
                }}
              />
              <p>
                Окно исчезнет после <Link to={links.login}>Входа</Link> в
                аккаунт
              </p>
            </div>
          </Modal>
        )}
      </>
    );
};
